<template>
  <div
    class="quiz-column"
    :style="{ transform: `translateX(${viewTranslate}%)` }"
  >
    <div class="quiz-column__row -primary">
      <QuizRow
        :idList="primaryQuestions"
        :title="testViewSettings.primary_question"
        primary
      />
    </div>
    <div
      class="quiz-column__row"
      v-bind:key="index.toString()"
      v-for="(row, index) in questionQueue"
    >
      <QuizRow :title="row.heading" :idList="row.id_list" />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import QuizRow from "@/containers/QuizRow";

export default {
  name: "QuizColumn",
  components: {
    QuizRow
  },
  computed: {
    primaryQuestions: function() {
      const _primaryQuestions = [];

      this.allQuestions.forEach(element => {
        if (element.primary) {
          _primaryQuestions.push(element._id);
        }
      });

      return _primaryQuestions;
    },
    viewTranslate: function() {
      return -this.questionQueue.length * 100;
    },
    ...mapState({
      questionQueue: state => state.questionQueue,
      allQuestions: state => state.allQuestions,
      testViewSettings: state => state.testViewSettings
    })
  },
  methods: {
    ...mapActions({
      triggerScrollTop: "triggerScrollTop"
    })
  },
  watch: {
    questionQueue: function() {
      this.triggerScrollTop();
    }
  }
};
</script>

<style lang="scss" scoped>
.quiz-column {
  display: flex;
  transition: cta-transition(transform, 0.8s);
  height: 100%;
  flex-grow: 1;

  @include if-tablet {
    align-items: stretch;
  }

  &__row {
    flex-basis: 100%;
    min-width: 100%;
    padding: 0 spacer("m");

    @include if-tablet {
      align-self: stretch;
      padding: 0 spacer("l");
    }
  }
}
</style>
